import { SvgIcon, SvgIconProps } from '@mui/material';

const BannerCampaignIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M1 5C1 3.59987 1 2.8998 1.27248 2.36502C1.51217 1.89462 1.89462 1.51217 2.36502 1.27248C2.8998 1 3.59987 1 5 1H18C19.4001 1 20.1002 1 20.635 1.27248C21.1054 1.51217 21.4878 1.89462 21.7275 2.36502C22 2.8998 22 3.59987 22 5V18C22 19.4001 22 20.1002 21.7275 20.635C21.4878 21.1054 21.1054 21.4878 20.635 21.7275C20.1002 22 19.4001 22 18 22H5C3.59987 22 2.8998 22 2.36502 21.7275C1.89462 21.4878 1.51217 21.1054 1.27248 20.635C1 20.1002 1 19.4001 1 18V5Z'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M1 7.17651H4.70433C5.90715 7.17651 6.50856 7.17651 6.99186 7.47521C7.47517 7.77391 7.74413 8.31183 8.28204 9.38766L8.54149 9.90654C9.0794 10.9824 9.34836 11.5203 9.83166 11.819C10.315 12.1177 10.9164 12.1177 12.1192 12.1177H18.2941C19.8955 12.1177 20.6961 12.1177 21.2418 11.6855C21.3627 11.5897 21.472 11.4804 21.5678 11.3595C22 10.8138 22 10.0131 22 8.41181V8.41181'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path d='M5.32422 16.4412H15.2066' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
      </svg>
    </SvgIcon>
  );
};

export default BannerCampaignIcon;
